import {
  ApplyStatus,
  PublishStatus,
  SurveyPublishStatus,
} from "@graffer-inc/cloud-gov-core";
import { StatusValue as ProcManagementStatus } from "../application/domain/proc-management";
import { reportUnexpectedError } from "../error-reporter";

let isLocalStorageEnabled: boolean | undefined = undefined;

export type LocalStorageEntities = {
  ApplyStatusFilter: ApplyStatus[];
  ProcedureStatusFilter: PublishStatus[];
  ProcManagementStatusFilter: ProcManagementStatus[];
  SurveyStatusFilter: SurveyPublishStatus[];
};

// LocalStorage有効チェック
export const validateLocalStorage = (): boolean => {
  if (typeof isLocalStorageEnabled === "undefined") {
    try {
      const localStorageEnabled = "LocalStorageEnabled";
      localStorage.setItem(localStorageEnabled, localStorageEnabled);
      localStorage.removeItem(localStorageEnabled);
      isLocalStorageEnabled = true;
    } catch (e) {
      isLocalStorageEnabled = false;
    }
  }

  return isLocalStorageEnabled;
};

/**
 * 当functionの戻り値は as で想定する型にcastする
 */
export const getLocalStorageItem = <T extends keyof LocalStorageEntities>(
  key: T,
): LocalStorageEntities[T] | undefined => {
  if (!validateLocalStorage()) return undefined;

  try {
    const item = localStorage.getItem(key);
    if (!item) {
      return undefined;
    }
    const json = JSON.parse(item);
    if (!json) {
      return undefined;
    }
    return json;
  } catch (error) {
    reportUnexpectedError(error);
    return undefined;
  }
};
export const setLocalStorageItem = <T extends keyof LocalStorageEntities>(
  key: T,
  value: LocalStorageEntities[T],
) => {
  if (!validateLocalStorage()) return;

  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    reportUnexpectedError(error);
  }
};

export const removeLocalStorageItem = (key: string) => {
  if (!validateLocalStorage()) return;

  try {
    localStorage.removeItem(key);
  } catch (error) {
    reportUnexpectedError(error);
  }
};
